import React from 'react';
import { motion } from 'framer-motion';
import { FaBuilding, FaBullseye, FaEye, FaCheck } from 'react-icons/fa';
import skyImage from './assets/sevenky_logos.png';

const About = () => {
  const objectives = [
    <>
      The <strong>"Seven"</strong> reflects a holistic approach to innovation across seven pillars: <strong>AI, Robotics, Embedded Systems, Control, Education, Sustainability,</strong> and <strong>Human-Machine Collaboration</strong>.
    </>,
    <>
      The suffix <strong>"-ky"</strong> echoes "sky", emphasizing <strong>limitless aspiration</strong>, or "key", symbolizing access to <strong>breakthrough possibilities</strong>.
    </>,
    <>
      Together, <strong>Sevenky = "Unlocking Seven Frontiers of Innovation"</strong>.
    </>
  ];

  return (
    <section
      id="about"
      style={{
        padding: '60px 20px',
        background: '#f0f8ff',
        fontFamily: 'Roboto',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{ textAlign: 'center', marginBottom: '50px' }}
      >
        <div
          style={{
            display: 'inline-block',
            background: '#007bff',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '24px',
            padding: '12px 35px',
            borderRadius: '25px',
            textTransform: 'uppercase',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          }}
        >
          About Us
        </div>
        <p
          style={{
            color: 'blue',
            fontSize: '22px',
            marginTop: '20px',
            fontWeight: 'bold',
            letterSpacing: '1px',
          }}
        >
          Bridging Innovation and Integration
        </p>
      </motion.div>

      {/* Two Column Grid */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '40px',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100%',
          maxWidth: '1600px',
          margin: '0 auto',
          boxSizing: 'border-box',
        }}
      >
        {/* Left Column */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={{
            flex: '1 1 500px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
            padding: '40px',
            boxSizing: 'border-box',
          }}
        >
          <div>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <img
                src={skyImage}
                alt="Sevenky Office"
                style={{
                  width: '100%',
                  maxWidth: '480px',
                  height: 'auto',
                  background: '#f8f9fa',
                  borderRadius: '10px',
                }}
                draggable="false"
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>

            {objectives.map((objective, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '20px',
                }}
              >
                <div
                  style={{
                    width: '30px',
                    height: '30px',
                    background: 'linear-gradient(to right, #6b46c1, #3182ce)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    marginRight: '12px',
                    flexShrink: 0,
                  }}
                >
                  <FaCheck size={12} />
                </div>
                <p
                  style={{
                    color: 'black',
                    fontSize: '18px',
                    margin: 0,
                  }}
                >
                  {objective}
                </p>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Right Column */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={{
            flex: '1 1 500px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '20px',
          }}
        >
          {/* Company Overview */}
          <div
            style={{
              background: 'white',
              padding: '30px',
              borderRadius: '20px',
              boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
              flexGrow: 1,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  background: 'linear-gradient(to right, #6b46c1, #3182ce)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  marginRight: '12px',
                  flexShrink: 0,
                }}
              >
                <FaBuilding size={20} />
              </div>
              <h3 style={{ fontSize: '22px', margin: 0 }}>Company Overview</h3>
            </div>
            <p style={{ color: 'black', fontSize: '18px' }}>
              Sevenky Technologies Pvt. Ltd. (7Ky) is a deep-tech startup bridging academic research and indigenous industrial innovation. It specializes in Robotics, Embedded Systems, IoT, Control Systems, and AI/ML-enabled solutions, developing Make in India prototypes and innovations across healthcare, agriculture, energy, and logistics.
            </p>
          </div>

          {/* Mission */}
          <div
            style={{
              background: 'white',
              padding: '30px',
              borderRadius: '20px',
              boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
              flexGrow: 1,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  background: 'linear-gradient(to right, #ed64a6, #e53e3e)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  marginRight: '12px',
                  flexShrink: 0,
                }}
              >
                <FaBullseye size={20} />
              </div>
              <h3 style={{ fontSize: '22px', margin: 0 }}>Mission</h3>
            </div>
            <p style={{ color: 'black', fontSize: '18px' }}>
              Driving innovation by integrating engineering principles, research insights, and practical training to solve real-world challenges and foster next-generation talent.
            </p>
          </div>

          {/* Vision */}
          <div
            style={{
              background: 'white',
              padding: '30px',
              borderRadius: '20px',
              boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
              flexGrow: 1,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  background: 'linear-gradient(to right, #4299e1, #0bc5ea)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  marginRight: '12px',
                  flexShrink: 0,
                }}
              >
                <FaEye size={20} />
              </div>
              <h3 style={{ fontSize: '22px', margin: 0 }}>Vision</h3>
            </div>
            <p style={{ color: 'black', fontSize: '18px' }}>
              To become a leading provider of transformative technology that empowers industries, academia, and society.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
